const getApiURL = () => process.env.GATSBY_API_URL;

// eslint-disable-next-line import/prefer-default-export
export { getApiURL };
